import {
  UPDATE_CURRENT_EXCHANGE_RATE,
  UPDATE_USER_LOCATION,
  UPDATE_USER_STATE_LOCATION,
} from "./types";

function setLocation(data) {
  return {
    type: UPDATE_USER_LOCATION,
    payload: data,
  };
}

function setStateLocation(data) {
  return {
    type: UPDATE_USER_STATE_LOCATION,
    payload: data,
  };
}

function setExchangeRate(data) {
  return {
    type: UPDATE_CURRENT_EXCHANGE_RATE,
    payload: data,
  };
}

const Actions = {
  setLocation,
  setStateLocation,
  setExchangeRate,
};

export default Actions;
